module.exports = __webpack_public_path__ + "media/images/patterns/otis_redding-2abed0d18745b2fc713bc16e70dabce8.png";